import * as React from 'react';
import { Box, Typography, Button, Paper, Alert } from '@mui/material';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { ACCENT, ACCENT_LIGHT, GRAY_300, btnPrimary } from './PresentationWizard.styles';

function UploadStep({ pptxFile, pptxError, setPptxError, dragActive, fileInputRef, handleBrowseFiles, handleFileChange, handleDrag, handleDrop, clearPptx }) {
  return (
    <Box sx={{ marginBottom: '32px' }}>
      <Typography
        variant="body2"
        sx={{ color: '#64748b', marginBottom: '24px' }}
      >
        Upload a single file to create a presentation. Supported file types: .doc, .docx, .pdf, .eml, .msg, .pptx.
      </Typography>
      <Typography variant="body2" sx={{ color: '#2A3547', display: 'flex', alignItems: 'center', gap: 1 }}>
        Selected: {pptxFile ? (
          <>
            {pptxFile.name}
            <Button size="small" onClick={clearPptx} sx={{ textTransform: 'none' }}>
              Clear
            </Button>
          </>
        ) : ''}
      </Typography>
      {pptxError && (
        <Alert severity="error" sx={{ mt: 2 }} onClose={() => setPptxError(null)}>
          {pptxError}
        </Alert>
      )}
      <Box sx={{ display: 'flex', justifyContent: 'center' }}>
        <Paper
          variant="outlined"
          onDragEnter={handleDrag}
          onDragLeave={handleDrag}
          onDragOver={handleDrag}
          onDrop={handleDrop}
          sx={{
            width: '50%',
            border: dragActive
              ? `2px dashed ${ACCENT}`
              : `2px dashed ${GRAY_300}`,
            backgroundColor: dragActive ? ACCENT_LIGHT : 'transparent',
            borderRadius: '12px',
            padding: '48px',
            textAlign: 'center',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            '&:hover': {
              borderColor: ACCENT,
              backgroundColor: ACCENT_LIGHT,
            },
          }}
          onClick={handleBrowseFiles}
        >
          <input
            ref={fileInputRef}
            type="file"
            accept=".doc,.docx,.pdf,.eml,.msg,.pptx"
            onChange={handleFileChange}
            style={{ display: 'none' }}
          />
          <CloudUploadIcon
            sx={{ fontSize: '48px', color: ACCENT, marginBottom: '16px' }}
          />
          <Button
            variant="contained"
            sx={{ ...btnPrimary, padding: '10px 32px', marginBottom: '12px' }}
          >
            Browse File
          </Button>
          <Typography
            variant="body2"
            sx={{ color: '#64748b', marginBottom: '8px' }}
          >
            or drag a file here to upload
          </Typography>
          <Typography variant="caption" sx={{ color: '#94a3b8' }}>
            Maximum file size: <strong>5MB</strong>
          </Typography>
        </Paper>
      </Box>
    </Box>
  );
}

export default UploadStep;
